import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { capitalize } from 'lodash';
import { ETLJobRecurrenceEnum } from '~/api/types';

const FrequencySelect = () => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const frequency = watch('frequency');

  useEffect(() => {
    if (frequency === ETLJobRecurrenceEnum.NOT_REPEAT) {
      setValue('end_date', null, { shouldDirty: true, shouldValidate: true });
    }
  }, [frequency]);

  return (
    <Controller
      name="frequency"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          label="RECURRENCE"
          required
          control={
            <>
              <FormHelperText error={!!errors.frequency}>{errors.frequency?.message as string}</FormHelperText>
              <Select {...field} error={!!errors.frequency}>
                {Object.keys(ETLJobRecurrenceEnum).map((key) => (
                  <MenuItem key={key} value={ETLJobRecurrenceEnum[key as keyof typeof ETLJobRecurrenceEnum]}>
                    {capitalize(key).replace('_', ' ')}
                  </MenuItem>
                ))}
              </Select>
            </>
          }
        />
      )}
    />
  );
};

export default FrequencySelect;
